// TODO(Carina): get this from @shinetools/geo-library once bumped (breaking changes)
export const FRENCH_DROM_COUNTRY_CODES = ['GF', 'GP', 'MQ', 'RE', 'YT'];
